var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashbin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84992 6.86667C6.14447 6.86667 6.38325 7.10545 6.38325 7.4V13.8C6.38325 14.0946 6.14447 14.3333 5.84992 14.3333C5.55537 14.3333 5.31659 14.0946 5.31659 13.8V7.4C5.31659 7.10545 5.55537 6.86667 5.84992 6.86667Z",
    fill: "#C52A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51659 6.86667C8.81114 6.86667 9.04992 7.10545 9.04992 7.4V13.8C9.04992 14.0946 8.81114 14.3333 8.51659 14.3333C8.22203 14.3333 7.98325 14.0946 7.98325 13.8V7.4C7.98325 7.10545 8.22203 6.86667 8.51659 6.86667Z",
    fill: "#C52A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7166 7.4C11.7166 7.10545 11.4778 6.86667 11.1833 6.86667C10.8887 6.86667 10.6499 7.10545 10.6499 7.4V13.8C10.6499 14.0946 10.8887 14.3333 11.1833 14.3333C11.4778 14.3333 11.7166 14.0946 11.7166 13.8V7.4Z",
    fill: "#C52A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4499 4.2C15.4499 4.7891 14.9724 5.26667 14.3833 5.26667H13.8499V14.8667C13.8499 16.0449 12.8948 17 11.7166 17H5.31659C4.13838 17 3.18325 16.0449 3.18325 14.8667V5.26667H2.64992C2.06081 5.26667 1.58325 4.7891 1.58325 4.2V3.13333C1.58325 2.54423 2.06081 2.06667 2.64992 2.06667H6.38325C6.38325 1.47756 6.86082 1 7.44992 1H9.58325C10.1724 1 10.6499 1.47756 10.6499 2.06667H14.3833C14.9724 2.06667 15.4499 2.54423 15.4499 3.13333V4.2ZM4.37582 5.26667L4.24992 5.32962V14.8667C4.24992 15.4558 4.72748 15.9333 5.31659 15.9333H11.7166C12.3057 15.9333 12.7833 15.4558 12.7833 14.8667V5.32962L12.6573 5.26667H4.37582ZM2.64992 4.2V3.13333H14.3833V4.2H2.64992Z",
    fill: "#C52A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashbin);
export default __webpack_public_path__ + "static/media/trashbin.9ed7d777f0c9ee7f598aa251d0a33c13.svg";
export { ForwardRef as ReactComponent };